/* DATORACODE - Add-to-Cart Modal */
(function () {
  const modal = document.getElementById('atc-modal');
  if (!modal) return;

  const infoContainer = document.getElementById('atc-modal__info');
  const contentEl = modal.querySelector('.atc-modal__content');
  let activeTrigger = null;
  /* DATORACODE - Race-Guard: laufende Fetch-Requests abbrechen können */
  let abortController = null;

  /* DATORACODE - Shared open/close/scroll-lock/escape via ModalHelper (CFSN-516) */
  const helper = new ModalHelper(modal, {
    overlaySelector: '.atc-modal__overlay',
    closeSelector: '.atc-modal__close',
    focusTarget: () => contentEl,
    onClose: () => {
      /* Race-Guard: laufenden Fetch abbrechen, damit kein stales Modal aufpoppt */
      if (abortController) {
        abortController.abort();
        abortController = null;
      }
      infoContainer.innerHTML = '';
      activeTrigger = null;
    },
  });

  /* ─── 1. Globaler Click-Handler ─── */
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-atc-modal-trigger]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();

    const productUrl = trigger.dataset.productUrl;
    if (!productUrl) return;

    const variantId = trigger.dataset.variantId;
    openModal(productUrl, variantId, trigger);
  });

  /* ─── 2. Modal öffnen + Fetch ─── */
  async function openModal(productUrl, variantId, trigger) {
    /* DATORACODE - Race-Guard: vorherigen Fetch abbrechen, bevor neuer startet */
    if (abortController) abortController.abort();
    abortController = new AbortController();
    var signal = abortController.signal;

    activeTrigger = trigger;

    /* Loading-State am Trigger */
    trigger.classList.add('loading');
    var spinner = trigger.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    /* Fetch-URL zusammenbauen */
    var url = new URL(productUrl, window.location.origin);
    url.searchParams.set('section_id', 'add-to-cart-modal');
    if (variantId) url.searchParams.set('variant', variantId);
    var fetchUrl = url.pathname + url.search;

    try {
      var response = await fetch(fetchUrl, { signal });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      var html = await response.text();

      /* DATORACODE - Stale Response verwerfen, falls inzwischen neuer Fetch läuft */
      if (signal.aborted) return;

      /* HTML einsetzen — <product-info> initialisiert sich via connectedCallback */
      if (typeof HTMLUpdateUtility !== 'undefined' && HTMLUpdateUtility.setInnerHTML) {
        HTMLUpdateUtility.setInnerHTML(infoContainer, html);
      } else {
        infoContainer.innerHTML = html;
      }

      /* DATORACODE — inject properties[_gift] when trigger is a gift */
      if (trigger.dataset.gift === 'true') {
        var giftForm = infoContainer.querySelector('form');
        if (giftForm && !giftForm.querySelector('input[name="properties[_gift]"]')) {
          var giftInput = document.createElement('input');
          giftInput.type = 'hidden';
          giftInput.name = 'properties[_gift]';
          giftInput.value = '';
          giftForm.appendChild(giftInput);
        }
      }

      /* Modal sichtbar machen + Scroll nach oben (helper handles body scroll-lock + focus trap) */
      /* DATORACODE - restoreFocusTo: Trigger explizit übergeben, da activeElement
         nach dem await nicht mehr zwingend der Trigger ist (Tab/Klick während Fetch). */
      helper.open({ restoreFocusTo: trigger });
      contentEl.scrollTop = 0;

      /* DATORACODE - Datora Discount-Preise aktualisieren */
      if (typeof updateProductGridDiscounts === 'function') {
        updateProductGridDiscounts(infoContainer);
      }
    } catch (err) {
      /* DATORACODE - Abbruch durch neueren Klick ist kein Fehler */
      if (err.name === 'AbortError') return;
      console.error('ATC Modal: Fetch fehlgeschlagen', err);
      helper.close();
    } finally {
      trigger.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  /* ─── 3. Bild-Zoom ─── */
  document.addEventListener('click', function (e) {
    var imageWrapper = e.target.closest('.atc-modal__image');
    if (!imageWrapper || !helper.isOpen()) return;

    var img = imageWrapper.querySelector('img');
    if (!img) return;

    /* Große Version: aktuelle img-URL nehmen und Breite auf 800 hochsetzen */
    var largeSrc = img.src.replace(/width=\d+/, 'width=800');
    var closeLabel = modal.dataset.closeLabel || '';

    /* DATORACODE - XSS-Hardening: DOM-API statt innerHTML-Concat mit user-facing Strings (img.alt) */
    var zoom = document.createElement('div');
    zoom.className = 'atc-modal__zoom';

    var zoomWrapper = document.createElement('div');
    zoomWrapper.className = 'atc-modal__zoom-img-wrapper';

    var zoomCloseBtn = document.createElement('button');
    zoomCloseBtn.type = 'button';
    zoomCloseBtn.className = 'atc-modal__zoom-close';
    zoomCloseBtn.setAttribute('aria-label', closeLabel);
    zoomCloseBtn.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="2" y1="2" x2="14" y2="14"/><line x1="14" y1="2" x2="2" y2="14"/></svg>';

    var zoomImg = document.createElement('img');
    zoomImg.src = largeSrc;
    zoomImg.alt = img.alt || '';

    zoomWrapper.appendChild(zoomCloseBtn);
    zoomWrapper.appendChild(zoomImg);
    zoom.appendChild(zoomWrapper);

    document.body.appendChild(zoom);

    /* DATORACODE - Fade-In */
    requestAnimationFrame(function () {
      zoom.classList.add('is-visible');
    });

    /* DATORACODE - Fade-Out bei Klick auf Zoom-Overlay oder Close-Button */
    zoom.addEventListener('click', function () {
      zoom.classList.remove('is-visible');
      zoom.addEventListener('transitionend', function () {
        zoom.remove();
      }, { once: true });
    });
  });

  /* ─── 4. Nach Cart-Update → Modal schließen ─── */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      if (helper.isOpen()) helper.close();
    });

    /* ─── 5. Bild + Datora-Preise nach Variantenwechsel aktualisieren ─── */
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!helper.isOpen()) return;
      var sectionId = event.data?.sectionId;
      if (sectionId !== 'add-to-cart-modal') return;

      /* Produktbild aus dem gefetchten HTML aktualisieren */
      var html = event.data?.html;
      if (html) {
        var newImage = html.getElementById('ProductImage-add-to-cart-modal');
        var currentImage = document.getElementById('ProductImage-add-to-cart-modal');
        if (newImage && currentImage) {
          currentImage.innerHTML = newImage.innerHTML;
        }
      }

      /* DATORACODE - Datora Discount-Preise aktualisieren */
      if (typeof updateProductGridDiscounts === 'function') {
        updateProductGridDiscounts(infoContainer);
      }
    });
  }
})();
